import React from 'react';

import styles from './LinksWrapper.module.scss';

interface Props {
  children: Array<React.ReactNode>;
}

const LinksWrapper: React.FC<Props> = (props: Props) => {
  if (props.children.length !== 2) {
    throw new Error('LinksWrapper: Expected exactly 2 children');
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>{props.children[0]}</div>
      <div className={styles.column}>{props.children[1]}</div>
    </div>
  );
};

LinksWrapper.displayName = 'LinksWrapper';

export default LinksWrapper;
